var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.067 14.212v-.279a2.933 2.933 0 0 1 5.866 0v.279M13.202 4.4l-2.2 6.6m-5.5-4.4a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733h0m12.467 3.667a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733h0M16.502 6.6a.367.367 0 1 0 .365.367.367.367 0 0 0-.367-.367h0M8.435 3.667a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.221 16.999a15.403 15.403 0 0 0-18.442 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.035 10.267a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.99000b76.svg";
export { ForwardRef as ReactComponent };